// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-27Nlk","text":"text-33A0i","signIn":"signIn-3oUf_","signIn__skip":"signIn__skip-2a13F"};